<template>
  <section
    class="has-background-primary-light p-3 is-radius-large"
    :class="{ 'is-full-width': inInEditMode }"
    :data-e2e="AICypressAttribute.views.CLARA_QUESTION_PILL"
  >
    <template v-if="inInEditMode">
      <FormTextarea
        v-if="inInEditMode"
        v-model="messageToEdit.text"
        ref="questionInput"
        :auto-height="true"
        :show-float-label="false"
        rows="2"
        :data-e2e="AICypressAttribute.inputs.CLARA_QUESTION_PILL_TEXTAREA"
      />
      <div class="is-flex is-justify-content-flex-end has-gap-10">
        <ButtonView
          class="button is-primary is-light"
          @click="onCancelEdit"
          :data-e2e="AICypressAttribute.buttons.CLARA_QUESTION_PILL_CANCEL"
        >
          <span>{{ $t('core.cancel') }}</span>
        </ButtonView>
        <ButtonView
          class="button is-primary"
          :disabled="!messageToEdit.text"
          @click="onConfirmEdit"
          :data-e2e="AICypressAttribute.buttons.CLARA_QUESTION_PILL_CONFIRM"
        >
          <span>{{ $t('user.confirm') }}</span>
        </ButtonView>
      </div>
    </template>
    <p v-else>
      {{ message.text }}
    </p>
  </section>
</template>

<script>
import { ClaraMessageStatusType } from '@/modules/ai/constants/ClaraMessageStatusType';
import { ClaraMessageObject } from '@/modules/ai/models/ClaraMessageObject';
import { AICypressAttribute } from '@/modules/ai/constants/AICypressAttribute';
import FormTextarea from '@/modules/core/form/components/FormTextarea.vue';
import ButtonView from '@/modules/core/ui/components/wrappers/ButtonView.vue';

export default {
  compatConfig: {
    COMPONENT_V_MODEL: true
  },
  name: 'ClaraQuestionPill',
  emits: ['on-cancel', 'on-confirm'],
  components: {
    FormTextarea,
    ButtonView
  },
  props: {
    message: {
      type: ClaraMessageObject,
      required: true
    },
    inInEditMode: {
      type: Boolean,
      default: false
    }
  },
  static: {
    AICypressAttribute
  },
  data() {
    return {
      originalQuestion: this.message.text
    };
  },
  computed: {
    messageToEdit() {
      return this.message;
    }
  },
  methods: {
    onCancelEdit() {
      this.messageToEdit.text = this.originalQuestion;
      this.$emit('on-cancel');
    },
    onConfirmEdit() {
      this.messageToEdit.status = ClaraMessageStatusType.CREATED;
      this.$emit('on-confirm', this.messageToEdit);
    }
  }
};
</script>

<style scoped>
:deep(.form-input) {
  margin-bottom: var(--ce-10px) !important;
}

:deep(.form-input textarea) {
  border: none;
  resize: none;
}
</style>
